import axios from 'axios';
import { env } from '../env';

import { IAssistantResponse } from '@interfaces/assistantQuery';

const { REACT_APP_API_URL } = env;

export default class AssistantQueryServiceService {
  static async queryAssistant(config: any = {}): Promise<IAssistantResponse> {
    const { data } = await axios.post(
      `${REACT_APP_API_URL}api/v2/assistant/query/model`,
      {
        ...config,
      },
    );

    return data;
  }

  static async generateAssistantAudio(config: any = {}): Promise<ArrayBuffer> {
    const { data } = await axios.post(
      `${REACT_APP_API_URL}api/v2/assistant/query/audio`,
      {
        ...config,
      },
      { responseType: 'arraybuffer' },
    );

    return data;
  }

  static async flagAssistantReply(config: any = {}): Promise<any> {
    const { data } = await axios.post(
      `${REACT_APP_API_URL}api/v2/assistant/query/model/feedback`,
      {
        ...config,
      },
    );

    return data;
  }
}
